import { addBreadcrumb } from "@sentry/browser";

import { httpErrorFromResponse, WpsBackendError } from "./errors";

export function assertOk(
  response: Response,
  extra_debug?: { [key: string]: unknown }
): Response {
  if (response.ok) {
    // maybe mistakes
    if (response.status === 204) {
      // we're missing details on 204 responses, log for now
      // in sentry : "GET: [Filtered] [204]"
      // see: https://demarque.sentry.io/issues/7051413565/events/6da01d62347e4506b32cb55621ec1e44/
      addBreadcrumb({
        category: "wps",
        message: `Received 204 No Content`,
        level: "info",
        data: extra_debug,
      });
    }
    return response;
  }

  const sentryEventId = response.headers.get("X-Error-Event-ID");
  if (response.status === 500 && sentryEventId) {
    addBreadcrumb({
      category: "wps",
      message: "Received 500 Internal Server Error",
      level: "error",
      data: { ...(extra_debug || {}), sentryEventId },
    });
    throw new WpsBackendError(sentryEventId);
  }

  addBreadcrumb({
    category: "wps",
    message: `[${response.status}] Failed to fetch from WPS`,
    level: "warning",
    data: extra_debug,
  });

  throw httpErrorFromResponse(response, extra_debug);
}

export function assertJson<T>(
  response: Response,
  extra_debug?: { [key: string]: unknown }
): Promise<T> {
  return assertOk(response, extra_debug).json<T>();
}
